var styles = {"link":"DirectionButton_link_1exxc_1","button":"DirectionButton_button_1exxc_2","arrow":"DirectionButton_arrow_1exxc_55","prev":"DirectionButton_prev_1exxc_59","next":"DirectionButton_next_1exxc_63","button-type":"DirectionButton_button-type_1exxc_102","hide-on-mobile":"DirectionButton_hide-on-mobile_1exxc_109"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
